import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomCategoryNavigationComponent } from './custom-category-navigation.component';
import { CustomNavigationModule } from '../custom-navigation.module';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';

@NgModule({
  imports: [
    CommonModule,
    CustomNavigationModule,
    CustomIconsModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        CategoryNavigationComponent: {
          component: CustomCategoryNavigationComponent,
          data: {
            resetMenuOnClose: true,
          },
        },
      },
    }),
  ],
  declarations: [CustomCategoryNavigationComponent],
  exports: [CustomCategoryNavigationComponent],
})
export class CustomCategoryNavigationModule {}
